import React from "react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { EmailNotification } from "@/api/getEmailNotifications/types";
import {
  EllipsisVerticalIcon,
  EyeIcon,
  CheckIcon,
} from "@heroicons/react/24/outline";

/**
 * Props for the dropdown actions:
 *  - notification: The current EmailNotification row
 *  - onApprove: callback to show approve modal
 *  - onPreview: callback to show preview modal
 */
interface EmailNotificationActionMenuProps {
  notification: EmailNotification;
  onApprove: (notif: EmailNotification) => void;
  onPreview: (notif: EmailNotification) => void;
}

const EmailNotificationActionMenu: React.FC<
  EmailNotificationActionMenuProps
> = ({ notification, onApprove, onPreview }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="h-8 w-8 p-0 hover:bg-gray-200" variant="ghost">
          <span className="sr-only">Open actions menu</span>
          <EllipsisVerticalIcon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-[160px] p-2 bg-white">
        {!notification.approved && (
          <DropdownMenuItem
            className="flex cursor-pointer items-center px-3 py-2 text-sm hover:bg-gray-100"
            onClick={() => onApprove(notification)}
          >
            <CheckIcon className="mr-2 h-4 w-4 text-gray-500" />
            Approve
          </DropdownMenuItem>
        )}

        <DropdownMenuItem
          className="flex cursor-pointer items-center px-3 py-2 text-sm hover:bg-gray-100"
          onClick={() => onPreview(notification)}
        >
          <EyeIcon className="mr-2 h-4 w-4 text-gray-500" />
          Preview
        </DropdownMenuItem>

        {/* Optionally add a separator or more actions if you wish */}
        {/*<DropdownMenuSeparator className="my-1 h-px bg-gray-200" />*/}

        {/* Example: if you had a "Delete" or other action, you'd place it here */}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default EmailNotificationActionMenu;
